(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brief-product"] && !Shopify.designMode) return;
  try {
    
  // --- Mobile toggle (accordion-like behavior) ---
  document.querySelectorAll('.mobile-tab-button').forEach((button) => {
    button.addEventListener('click', () => {
      const tab = button.getAttribute('data-tab');
      const content = document.getElementById(tab);
      const isActive = button.classList.contains('active');

// Close all
      document.querySelectorAll('.mobile-tab-button').forEach((btn) => {
        btn.classList.remove('active');
        btn.querySelector('.icon').textContent = '+';
      });
      document.querySelectorAll('.mobile-tab-content').forEach((content) => {
        content.classList.remove('active');
      });

// Open if it wasn't already open
      if (! isActive) {
        button.classList.add('active');
        button.querySelector('.icon').textContent = '-';
        content.classList.add('active');

// Judge.me refresh
        if (tab === 'reviews' && window.judgeme) {
          setTimeout(() => {
            window.judgeme.refreshWidgets();
          }, 300);
        }
      }
    });
  });

// --- Desktop Tabs ---
  document.querySelectorAll('.tab-button').forEach((button) => {
    button.addEventListener('click', () => {
      const tab = button.getAttribute('data-tab');

// Reset buttons
      document.querySelectorAll('.tab-button').forEach((btn) => btn.classList.remove('active'));
      button.classList.add('active');

// Reset content
      document.querySelectorAll('.tab-pane').forEach((pane) => pane.classList.remove('active'));
      document.getElementById(tab + '-desktop').classList.add('active');

// Judge.me refresh
      if (tab === 'reviews' && window.judgeme) {
        setTimeout(() => {
          window.judgeme.refreshWidgets();
        }, 300);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
     

 document.addEventListener('DOMContentLoaded', () => {
    const testimonialSlider = document.querySelector('.testimonial-slider');

    if (testimonialSlider) {
      const swiper = new Swiper(testimonialSlider, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        centeredSlides: true,
        grabCursor: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.testimonial-pagination',
          clickable: true,
          dynamicBullets: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 1,
            // spaceBetween: 20,
          },
          768: {
            slidesPerView: 1,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      });
    }
  });


  } catch(e) { console.error(e); }
})();
})();
